import React from 'react'

import {CircularProgress, Typography, withStyles} from '@material-ui/core';
import Main from '../../../container/Main'

import style from './style'

const RawLoading = ({classes}) =>
    <div className={classes.main}>
        <CircularProgress
            className={classes.loading}
            size={46}
            thickness={5}
        />
        <Typography variant="body1" className={classes.text}>Su operación se está procesando</Typography>
    </div>

/**
 * This is the standalone loading component.
 */
const Loading = withStyles(style)(RawLoading)

export {Loading}

/**
 * This is the Loading screen.
 */
export default Main(Loading)
